import { Fancybox } from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox/fancybox.css';
import URL_PREFIX from '../common/url_prefix';

Fancybox.bind('[data-fancybox="gallery"]', {
  Carousel: {
    infinite: false,
  },
  // nextEffect: 'fade',
  // prevEffect: 'fade',
  // loop: false,
  // helpers: {
  //   overlay: {
  //     locked: false,
  //   },
  // },
});

// 1. Select all thumbnail <li> elements
const thumbnails = document.querySelectorAll('.thumbnails ul li');

// 2. Attach click event to each thumbnail
thumbnails.forEach((thumbnail) => {
  thumbnail.addEventListener('click', () => {
    // Get the ID from data-id attribute
    const dataId = thumbnail.getAttribute('data-id'); // or thumbnail.dataset.id
    if (!dataId) return;

    const targetEl = document.getElementById(dataId);

    // Proceed only if targetEl exists and is currently hidden
    if (targetEl && window.getComputedStyle(targetEl).display === 'none') {
      // Hide all .pictures li
      document.querySelectorAll('.pictures li').forEach((picLi) => {
        if (picLi instanceof HTMLElement) {
          // eslint-disable-next-line no-param-reassign
          picLi.style.display = 'none';
        }
      });

      // Show the clicked one
      targetEl.style.display = 'block';

      // Remove .active from all thumbnails
      thumbnails.forEach((thumb) => {
        thumb.classList.remove('active');
      });

      // Add .active to the clicked thumbnail
      thumbnail.classList.add('active');
    }
  });
});

document.querySelectorAll('.more').forEach((moreBtn) => {
  if (!(moreBtn instanceof HTMLElement)) return;

  moreBtn.addEventListener('click', () => {
    const { id } = moreBtn.dataset; // same as $(this).data('id')
    const el = document.getElementById(`review_${id}`); // #review_ID
    if (!el) return;

    const elBody = el.querySelector('.reviewBody');
    if (!(elBody instanceof HTMLElement)) return;

    // 1) Lock the current height & hide overflow
    const initialHeight = el.offsetHeight; // approximate the original jQuery .height()
    el.style.height = `${initialHeight}px`;
    el.style.overflow = 'hidden';

    // 2) Update the .reviewBody with the full review content
    const fullReviewEl = document.getElementById(`full_review_${id}`);
    if (fullReviewEl) {
      elBody.innerHTML = fullReviewEl.innerHTML; // replace content
    }

    // 3) Measure the new height after updating the content
    //    (temporarily set display to 'block' if it’s hidden, etc.)
    const newHeight = elBody.offsetHeight;

    // 4) Trigger the transition for 200ms
    el.style.transition = 'height 0.2s ease';
    // Use requestAnimationFrame to ensure the browser applies
    // the initial height before transitioning to the new height
    requestAnimationFrame(() => {
      el.style.height = `${newHeight}px`;
    });

    // 5) Optionally remove the inline transition after it's done
    setTimeout(() => {
      el.style.transition = '';
      // If you want the height to be "auto" again after the animation,
      // you can remove the inline height style:
      // el.style.height = '';
      // el.style.overflow = '';
    }, 200);
  });
});

const selectItem = document.querySelector('.selectItem');
const toolRight = document.querySelector('.toolRight');
const addToCart = document.querySelector('.addToCart');
const inCartElements = document.querySelectorAll('.inCart');
const priceSpan = document.querySelector('.price span');
const addToCartLoader = document.querySelector('.addToCartLoader');
const cartTopIconSpan = document.querySelector('.cartTopIcon span');
const checkout = document.querySelector('.checkout');
const inCartEls = document.querySelectorAll('.inCart');
const toolHere = document.querySelector('#toolHere');

const makeSelectWidth = () => {
  if (!(selectItem instanceof HTMLElement) || !(toolRight instanceof HTMLElement)) return;

  // Compare offsetWidths of both elements
  if (selectItem.offsetWidth > toolRight.offsetWidth) {
    selectItem.style.width = '100%';
  } else {
    selectItem.style.width = 'auto';
  }
};

function handleSelectItemChange() {
  if (!(selectItem instanceof HTMLSelectElement)) return; // Safeguard if element not found

  // Get the currently selected <option>
  const selectedOption = selectItem.options[selectItem.selectedIndex];
  if (!selectedOption) return;

  // Check "data-in_cart" attribute
  if (selectedOption.getAttribute('data-in_cart') === '1') {
    // Hide Add to Cart
    if (addToCart instanceof HTMLElement) {
      addToCart.style.display = 'none';
    }
    // Show .inCart elements
    inCartElements.forEach((el) => {
      if (el instanceof HTMLElement) {
        // eslint-disable-next-line no-param-reassign
        el.style.display = 'block';
      }
    });
  } else {
    // Show Add to Cart
    if (addToCart instanceof HTMLElement) {
      addToCart.style.display = 'block';
    }
    // Hide .inCart elements
    inCartElements.forEach((el) => {
      if (el instanceof HTMLElement) {
        // eslint-disable-next-line no-param-reassign
        el.style.display = 'none';
      }
    });
  }

  // Update price in .price span
  if (priceSpan) {
    const price = selectedOption.getAttribute('data-price');
    if (price) {
      priceSpan.textContent = price;
    }
  }
}

// Attach listeners
if (selectItem) {
  selectItem.addEventListener('change', handleSelectItemChange);
  selectItem.addEventListener('keyup', handleSelectItemChange);
}

// Ensure the button is shown initially (equivalent to jQuery’s $addToCart.show())
if (addToCart instanceof HTMLElement) {
  addToCart.style.display = 'block';
}

// Replace the jQuery .on('click') with a vanilla event listener
if (addToCart instanceof HTMLButtonElement) {
  addToCart.addEventListener('click', async () => {
    // Determine the type and ID
    let type = 'tool';
    let id = toolHere?.getAttribute('data-id');

    // If we have a select .selectItem, override type & id
    if (selectItem instanceof HTMLSelectElement) {
      type = 'spec';
      id = selectItem.value;
    }

    // Before sending the request
    addToCart.disabled = true;
    if (addToCartLoader instanceof HTMLElement) {
      addToCartLoader.style.display = 'inline-block';
    }

    if (!id) return;

    try {
      // Perform a POST request using fetch
      const response = await fetch(`${URL_PREFIX}/cart/add`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        // Convert data to form-encoded (same format jQuery would send by default)
        body: new URLSearchParams({
          id: String(id),
          type,
          quantity: '1',
        }),
      });

      if (response.ok) {
        // The server returns the updated count as JSON
        const count = await response.json();

        // Hide the loader and update cart count
        if (addToCartLoader instanceof HTMLElement) {
          addToCartLoader.style.display = 'none';
        }
        if (cartTopIconSpan) {
          cartTopIconSpan.textContent = count;
        }

        // Show/hide .checkout based on count
        if (checkout instanceof HTMLElement) {
          checkout.style.display = count > 0 ? 'block' : 'none';
        }

        // If we used the <select>, mark its chosen option as in-cart
        if (selectItem) {
          const option = selectItem.querySelector(`option[value="${id}"]`);
          if (option) {
            option.setAttribute('data-in_cart', '1');
          }
          // Call your existing function to handle UI updates
          handleSelectItemChange();
        } else {
          // Otherwise hide the addToCart button and show .inCart elements
          addToCart.style.display = 'none';
          inCartEls.forEach((el) => {
            if (el instanceof HTMLElement) {
              // eslint-disable-next-line no-param-reassign
              el.style.display = 'block';
            }
          });
        }

        // Re-enable the button
        addToCart.disabled = false;
      }
    } catch (error) {
      // If there's an error, hide loader & re-enable the button
      // console.error(error);
      if (addToCartLoader instanceof HTMLElement) {
        addToCartLoader.style.display = 'none';
      }
      addToCart.disabled = false;
    }
  });
}

window.addEventListener('resize', makeSelectWidth);

// if ($('.thumbnails li').length > 4) {
//   $('.thumbnails').scrollable({
//     speed: 300,
//   });
//
//   $('.scrollableButton.next').removeClass('disabled');
// }

handleSelectItemChange();
makeSelectWidth();

// 1. Grab the container and buttons
const thumbnailsContainer = document.querySelector('.thumbnails');
const prevButton = document.querySelector('.scrollableButton.prev');
const nextButton = document.querySelector('.scrollableButton.next');

// 2. Get a reference to the <li> items
const items = thumbnailsContainer ? thumbnailsContainer.querySelectorAll('li') : [];

// 3. Function to update the state of the Prev/Next buttons based on scroll position
function updateButtons() {
  if (!(thumbnailsContainer instanceof HTMLElement)
    || !(prevButton instanceof HTMLElement)
    || !(nextButton instanceof HTMLElement)) return;

  // The furthest we can scroll horizontally
  const maxScrollLeft = thumbnailsContainer.scrollWidth - thumbnailsContainer.clientWidth;

  // If scrollLeft is at or near 0, disable Prev
  if (thumbnailsContainer.scrollLeft <= 0) {
    prevButton.classList.add('disabled');
  } else {
    prevButton.classList.remove('disabled');
  }

  // If scrollLeft is at or near maxScrollLeft, disable Next
  if (thumbnailsContainer.scrollLeft >= maxScrollLeft) {
    nextButton.classList.add('disabled');
  } else {
    nextButton.classList.remove('disabled');
  }
}

// If no items or only 1 item, there's nothing to scroll
if (thumbnailsContainer && items.length > 4
  && prevButton instanceof HTMLElement
  && nextButton instanceof HTMLElement) {
  // 4. Measure the width of one item (including borders/padding)
  //    We'll use the first item as the reference for "one image" width
  const itemWidth = items[0].offsetWidth;

  // 5. Add event listeners to the Prev/Next buttons
  nextButton.addEventListener('click', () => {
    // Scroll one item to the right
    thumbnailsContainer.scrollBy({
      left: itemWidth + 3,
      behavior: 'smooth',
    });
  });

  prevButton.addEventListener('click', () => {
    // Scroll one item to the left
    thumbnailsContainer.scrollBy({
      left: -itemWidth - 3,
      behavior: 'smooth',
    });
  });

  // 6. Whenever the container scrolls (e.g., by clicking buttons or trackpad),
  //    update the button states
  thumbnailsContainer.addEventListener('scroll', updateButtons);

  // 7. Initialize button states on load
  updateButtons();
}
